export class ErrorResponse {
  code: string = ''
  message: string = ''
}
